(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["vue-form-notification"] = factory();
	else
		root["vue-form-notification"] = factory();
})((typeof self !== 'undefined' ? self : this), () => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__webpack_require__.p = "";
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ entry_lib)
});

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ const setPublicPath = (null);

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!../../node_modules/pug-plain-loader/index.js!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueFormNotification.vue?vue&type=template&id=b6f9fefc&lang=pug&
var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sf-form-notification",class:['sf-form-notification--' + _vm.type, 'sf-form-notification--icon-' + _vm.iconVisible,  { 'sf-form-notification--inverse' : (_vm.inverse && _vm.type == 'error'), 'sf-form-notification--has-title': _vm.$slots.title }],attrs:{"aria-live":_vm.liveRegion ? 'assertive' : 'off',"aria-atomic":"true"}},[_c('svg',{staticClass:"sf-form-notification__icon",attrs:{"aria-hidden":"true","width":"24","height":"24","viewbox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M12 15.75V8.25","stroke":_vm.type == 'warning' ? '#FC0' : '#FF435A',"stroke-width":"2","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M12 18C12.6904 18 13.25 18.5596 13.25 19.25C13.25 19.9404 12.6904 20.5 12 20.5C11.3096 20.5 10.75 19.9404 10.75 19.25C10.75 18.5596 11.3096 18 12 18Z","fill":_vm.type == 'warning' ? '#FC0' : '#FF435A'}}),_c('path',{attrs:{"d":"M13.5851 1.98771V1.98771C13.1551 1.11236 12.097 0.75131 11.2216 1.18128C10.871 1.3535 10.5874 1.63711 10.4152 1.98771L1.15287 20.8567V20.8567C0.790531 21.5938 1.09433 22.4851 1.83143 22.8475C2.03588 22.948 2.26068 23.0002 2.4885 23H21.5118V23C22.3332 23.0005 22.9995 22.3351 23 21.5138C23.0002 21.286 22.948 21.0612 22.8475 20.8567L13.5851 1.98771Z","stroke":_vm.type == 'warning' ? '#FC0' : '#FF435A',"stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})]),(_vm.$slots['title'])?_c('div',{staticClass:"sf-form-notification__title"},[_vm._t("title")],2):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []


;// CONCATENATED MODULE: ./src/components/constants.js
const TYPES = ['error', 'warning'];
const ICON_VISIBLE = {
	DESKTOP: 'desktop',
	MOBILE: 'mobile',
	BOTH: 'both'
};

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueFormNotification.vue?vue&type=script&lang=js&


/* harmony default export */ const VueFormNotificationvue_type_script_lang_js_ = ({
	name: 'VueFormNotification',
	props: {
		/**
		 * Sets the type of the notification.
		 * @values error, warning
		 */
		type: {
			type: String,
			default: TYPES[0],
			validator(val) {
				return TYPES.includes(val);
			}
		},
		/**
		 * Sets the icon for the current type.
		 */
		iconVisible: {
			type: String,
			default: ICON_VISIBLE.DESKTOP,
			validator(val) {
				return Object.values(ICON_VISIBLE).includes(val);
			}
		},
		/**
		 * Sets the inverse color schema of the current type.
		 */
		inverse: {
			type: Boolean,
			default: false
		},
		/**
		 * Sets the aria-live, aria-atomic attributes of the notification. Note: the slot has to be fed in delayed
		 * to make sure every screen reader gets notified of the update.
		 */
		liveRegion: {
			type: Boolean,
			default: true
		}
	}
});

;// CONCATENATED MODULE: ./src/components/VueFormNotification.vue?vue&type=script&lang=js&
 /* harmony default export */ const components_VueFormNotificationvue_type_script_lang_js_ = (VueFormNotificationvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-58.use[0]!../../node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-58.use[1]!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-58.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-58.use[3]!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueFormNotification.vue?vue&type=style&index=0&id=b6f9fefc&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/VueFormNotification.vue?vue&type=style&index=0&id=b6f9fefc&prod&lang=scss&

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

;// CONCATENATED MODULE: ./src/components/VueFormNotification.vue



;


/* normalize component */

var component = normalizeComponent(
  components_VueFormNotificationvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ const VueFormNotification = (component.exports);
;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ const entry_lib = (VueFormNotification);


__webpack_exports__ = __webpack_exports__["default"];
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=vue-form-notification.umd.js.map